// components/LoadingModal.js
import { useSelector } from 'react-redux';
import styled, { keyframes } from 'styled-components';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.overlayBackground};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const ModalContent = styled.div`
  background: ${({ theme }) => theme.colors.white};
  padding: 30px 50px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
`;

const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;

const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border: 6px solid ${({ theme }) => theme.colors.spinnerTrack};
  border-top: 6px solid ${({ theme }) => theme.colors.primaryBlue};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
  margin: 0 auto 15px auto;
`;

const Message = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.medium};
  color: ${({ theme }) => theme.colors.secondaryText};
`;

const LoadingModal = () => {
  const systemInfo = useSelector((state) => state.system);
  if (!systemInfo.showLoading) return null;

  return (
    <Overlay>
      <ModalContent>
        <Message>Loading, please wait...</Message>
        <Spinner />
      </ModalContent>
    </Overlay>
  );
};

export default LoadingModal;
